import { LinkProps } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";

import React, { useState } from "react";
import AppModal from "../../modal/AppModal";

interface ProtectedLinkProps extends LinkProps, Record<string, any> {
  to: string;
  children: React.ReactNode;
  allowedRoles?: string[];
}

const ProtectedLink: React.FC<ProtectedLinkProps> = ({
  to,
  children,
  allowedRoles,
  onClick,
  ...props
}) => {
  const { isAuthenticated, roles, isLoading } = useAuth();
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);

  if (isLoading) return null;

  const hasRole =
    !allowedRoles ||
    allowedRoles?.length === 0 ||
    allowedRoles?.some((role) => roles?.includes(role));

  const hasAccess = isAuthenticated && hasRole;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!hasAccess) {
      e.preventDefault();
      setShowErrorModal(true);
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <>
      <Link to={to} onClick={handleClick} {...props}>
        {children}
      </Link>

      <AppModal
        open={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        title="Access Denied"
      >
        <p>User does not have privileges to access this page.</p>
      </AppModal>
    </>
  );
};

export default ProtectedLink;
